import React, { useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import Productslider from "../../src/components/productslider";
import { Tooltip as ReactTooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import WarningSvg from "../assets/svg/warningSvg";
import QuestionMarkSvg from "../assets/svg/QuestionMarkSvg";


export default function buysell(props) {
  
  let navigate = useNavigate();

  // Shared icon style for consistent sizing
  const iconStyle = {
    flexShrink: 0,
    width: '20px',
    height: '20px',
    minWidth: '20px',
    minHeight: '20px',
    maxWidth: '20px',
    maxHeight: '20px',
    display: 'block',
    boxSizing: 'border-box',
    verticalAlign: 'middle'
  };

  const [showTooltip , setShowTooltip] = useState(false);

  const handleClick = () => {
    setShowTooltip(!showTooltip);
  }
  const handleMouseEnter = () => {
    setShowTooltip(true);
  };

  const handleMouseLeave = () => {
    setShowTooltip(false);
  };
  return (
    <div>
      <Container className="product_slider_page custom-font">
        {props.count == 0 ? (
          <div className="loader-icon" style={{ marginBlock: "80px" }}>
            <i className="fa-solid fa-spinner fa-spin-pulse"></i>
          </div>
        ) : props.count == 1 ? (
          <Row>
            <Col xs="12" sm="8">
          
              {
                props?.Image && (
                  <Productslider Data={props?.Image} count={props?.count} />
                )
              }

              {/* Image Disclaimer Text */}
              {props.count == 1 && props.imageData && (
                <p style={{ 
                  fontSize: 'clamp(11px, 1.5vw, 13px)', 
                  color: '#666',
                  marginTop: 'clamp(8px, 2vw, 12px)',
                  marginBottom: 'clamp(16px, 4vw, 24px)',
                  textAlign: 'left',
                  lineHeight: '1.5',
                }}>
                  Images are representative of this model. Every unit is verified by GPUwiz before shipment
                </p>
              )}
            </Col>
           {/* Right Side Buy Sell Buttons */}
            <Col className="d-flex justify-content-end justify-content-sm-end justify-content-center align-items-center" xs="12" sm="4">
              <div className="thumb-btns d-flex flex-column align-items-end align-items-sm-end align-items-center" style={{ width: '100%', maxWidth: 'clamp(200px, 30vw, 400px)', height: '100%', position: 'relative' }}>
                {/* Buttons Container - Vertically Centered, Right Aligned with spacing */}
                <div className="buttons-container-responsive" style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'flex-end', justifyContent: 'center', flex: '1', paddingRight: 'clamp(0px, 3vw, 40px)', paddingLeft: 'clamp(0px, 2vw, 30px)' }}>
                   <div style={{height : "65%"}}>
                     {props.type == 1 ? (
                      <>
                        <Button
                          className="py-3 px-5 mb-1 up-btn border-0 btn-responsive"
                          style={{ borderRadius: '50px', fontSize: 'clamp(14px, 2vw, 20px)', paddingLeft: 'clamp(20px, 4vw, 40px)', paddingRight: 'clamp(20px, 4vw, 40px)', minWidth: 'clamp(180px, 25vw, 280px)' , fontWeight : 650 }}
                          onClick={() => navigate("/bidask/" + props.prm + "/buy")}
                        >
                          Buy Now for ${props?.finalPriceBuy}
                        </Button>
                        <p style={{fontSize : 'clamp(11px, 2vw, 18px)' , fontWeight : 600}} className="w-100 d-flex justify-content-center align-items-center">
                          Lowest Ask
                        </p>
                      </>
                    ) : props.finalPriceBuy || props.FinalPriceSell ? (
                      <>
                        {props.finalPriceBuy ? (
                            <>
                              <Button
                                className="py-3 px-5 mb-1 up-btn border-0 btn-responsive"
                                style={{ borderRadius: '50px', fontSize: 'clamp(14px, 2vw, 20px)', paddingLeft: 'clamp(20px, 4vw, 40px)', paddingRight: 'clamp(20px, 4vw, 40px)', minWidth: 'clamp(180px, 25vw, 280px)' , fontWeight : 650}}
                                onClick={() =>
                                  navigate("/bidask/" + props?.prm + "/buy")
                                }
                              >
                                Buy Now for ${props?.finalPriceBuy}
                              </Button>
                              <p style={{fontSize : 'clamp(11px, 2vw, 18px)' , fontWeight : 600}} className="w-100 d-flex justify-content-center align-items-center">
                                Lowest Ask
                              </p>
                            </>
                        ) : (
                          ""
                        )}

                          { !localStorage.getItem("admin") ?
                    <>
                    <a
                      className="border border-black py-3 px-5 mb-1 mt-3 position-relative d-inline-flex align-items-center justify-content-center text-center btn-responsive-link"
                      style={{ borderRadius: '50px', fontSize: 'clamp(14px, 2vw, 20px)', textDecoration: 'none', color: '#000', paddingLeft: 'clamp(20px, 4vw, 40px)', paddingRight: 'clamp(20px, 4vw, 40px)', minWidth: 'clamp(180px, 25vw, 280px)' , fontWeight : 650 }}
                      onClick={() => navigate("/bidask/" + props.prm)}
                    >
                      <span className="pe-3">Make Offer</span>
                      <a 
                        href="javascript:void(0);" 
                        className="custom_tool_ttp position-relative d-inline-flex align-items-center justify-content-center" 
                        style={{ textDecoration: 'none', width: 'clamp(18px, 3vw, 22px)', height: 'clamp(18px, 3vw, 22px)', flexShrink: 0 }}
                        onClick={(e) => {
                          e.stopPropagation();
                        }}
                      >
                        <svg
                          id="place-bid-ask-tooltip"
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-question-circle-fill"
                          viewBox="0 0 16 16"
                        >
                          <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.496 6.033h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286a.237.237 0 0 0 .241.247zm2.325 6.443c.61 0 1.029-.394 1.029-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94 0 .533.425.927 1.01.927z" />
                        </svg>
                        <ReactTooltip
                          anchorId="place-bid-ask-tooltip"
                          className="custom-tooltip text-center"
                          place="bottom"
                          style={{ maxWidth: "240px" }}
                          clickable={true}
                          closeOnScroll={false}
                          content={
                            <>
                              Let the market know at what price you are committed to make a deal.{"\n\n"}
                              A Bid is the price at which you are willing to buy an item.{"\n\n"}
                              An Ask is the price you are willing to sell an item.{"\n\n"}
                              Your Bid/Ask will stay active until someone accept, expires or you cancel it.{"\n\n"}
                              If Someone accept your Bid/Ask there is no backing out!{"\n\n"}
                              For more information please see our{" "}
                              <a
                                href="/help/buying-and-Selling-Guide"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="buying-selling-guide-link"
                                style={{ textDecoration: "underline !important", color: "#0066ff !important" }}
                                onClick={(e) => e.stopPropagation()}
                              >
                                Buying and Selling Guide
                              </a>
                            </>
                          }
                        />
                      </a>
                    </a>

                    

                    <p style={{fontSize : 'clamp(11px, 2vw, 18px)' , fontWeight : 600}} className="w-100 d-flex justify-content-center align-items-center">
                      {`Highest Offer: ${props?.FinalPriceSell && props?.FinalPriceSell !== 0 && props?.FinalPriceSell !== "" ? `$${props?.FinalPriceSell}` : '-'}`}
                    </p>
                    </>
                    : <></>}


                          {props.FinalPriceSell ? (
                            <p onClick={() => {
                              localStorage.setItem('activeTab' , "ask");
                              navigate("/bidask/" + props?.prm)
                            }
                              
                            } style={{ fontSize: 'clamp(14px, 2vw, 19px)', fontWeight: 600, cursor: "pointer" }} className="w-100 d-flex justify-content-center align-items-center mt-4">
                              {`Sell Now for $${props?.FinalPriceSell} or ask for more →`}
                            </p>
                          ) : (
                            ""
                          )}
                  
                  
                  </>
                ) : (
                  <>
                  <a
                    className="border border-black py-3 px-5 mb-1 mt-3 position-relative d-inline-flex align-items-center justify-content-center text-center btn-responsive-link"
                    style={{ borderRadius: '50px', fontSize: 'clamp(14px, 2vw, 20px)', textDecoration: 'none', color: '#000', paddingLeft: 'clamp(20px, 4vw, 40px)', paddingRight: 'clamp(20px, 4vw, 40px)', minWidth: 'clamp(180px, 25vw, 280px)', fontWeight : 650 }}
                    onClick={() => navigate("/bidask/" + props?.prm)}
                  >
                    <span className="pe-3">Make Offer</span>
                    <a 
                      href="javascript:void(0);" 
                      className="custom_tool_ttp position-relative d-inline-flex align-items-center justify-content-center" 
                      style={{ textDecoration: 'none', width: 'clamp(18px, 3vw, 22px)', height: 'clamp(18px, 3vw, 22px)', flexShrink: 0 }}
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                    >
                      <svg
                        id="place-bid-ask-tooltip"
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-question-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.496 6.033h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286a.237.237 0 0 0 .241.247zm2.325 6.443c.61 0 1.029-.394 1.029-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94 0 .533.425.927 1.01.927z" />
                      </svg>
                      <ReactTooltip
                        anchorId="place-bid-ask-tooltip"
                        className="custom-tooltip text-center"
                        place="bottom"
                        style={{ maxWidth: "240px" }}
                        clickable={true}
                        closeOnScroll={false}
                        content={
                          <>
                            Let the market know at what price you are committed to make a deal.{"\n\n"}
                            A Bid is the price at which you are willing to buy an item.{"\n\n"}
                            An Ask is the price you are willing to sell an item.{"\n\n"}
                            Your Bid/Ask will stay active until someone accept, expires or you cancel it.{"\n\n"}
                            If Someone accept your Bid/Ask there is no backing out!{"\n\n"}
                            For more information please see our{" "}
                            <a
                              href="/help/buying-and-Selling-Guide"
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ textDecoration: "underline !important", color: "#0d6efd !important" }}
                              onClick={(e) => e.stopPropagation()}
                            >
                              Buying and Selling Guide
                            </a>
                          </>
                        }
                      />
                    </a>
                  </a>
                    <p style={{fontSize : 'clamp(11px, 2vw, 18px)' , fontWeight : 600}} className="w-100 d-flex justify-content-center align-items-center">
                      Highest Offer: {props?.FinalPriceSell &&  props?.FinalPriceSell != 0 && props?.FinalPriceSell != "" ? `$${props?.FinalPriceSell}` : "-"}
                    </p>
                  </>
                )}
                   </div>

                 {/* Deal Score & GPUwiz Verified - Bottom, Right Aligned */}
                <div style={{ 
                  display: 'flex', 
                  flexDirection: 'column',
                  gap: 'clamp(12px, 2.5vw, 16px)',
                  alignItems: 'flex-end',
                  width: '100%',
                  boxSizing: 'border-box',
      
                }} className="deal-score-container-responsive">
                  {/* Deal Score - First Line */}
                  <span className="deal-score-line p-0" style={{ 
                    display: 'flex', 
                    flexDirection: 'row',
                    gap: 'clamp(4px, 1vw, 8px)',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    flexWrap: 'nowrap',
                    width: '100%',
                    // paddingRight: (props?.dealScore && props?.dealScore !== 0) ? '68px' : '0px',
                    marginTop : "15px",
                    
                   
                  }}>
                    <svg 
                      viewBox="0 0 20 20" 
                      width="25"
                      height="20"
                      style={{...iconStyle, minWidth: '25px', minHeight: '20px'}}
                      preserveAspectRatio="xMidYMid meet"
                    >
                      <path 
                        d="M3.44722 18.1056L10.2111 4.57771C10.9482 3.10361 13.0518 3.10362 13.7889 4.57771L20.5528 18.1056C21.2177 19.4354 20.2507 21 18.7639 21H5.23607C3.7493 21 2.78231 19.4354 3.44722 18.1056Z" 
                        fill="#ff4400"
                      />
                      <circle cx="12" cy="17" r="1" fill="#ffffff" />
                      <path 
                        d="M12 10L12 14" 
                        stroke="#ffffff" 
                        strokeWidth="2" 
                        strokeLinecap="round" 
                        strokeLinejoin="round"
                      />
                    </svg>
                    <p className="mt-1" style={{ 
                      fontSize: "clamp(14px, 2vw, 19px)", 
                      fontWeight: 600, 
                      color: "#262626", 
                      textAlign: "right", 
                      marginBottom: "0px",
                      lineHeight: '1.2',
                      marginLeft: '1px',
                      flexShrink: 0
                    }}>
                      Deal Score: {props?.dealScore && props?.dealScore !== 0 ? props?.dealScore?.toFixed(2) : "Not Available"}
                    </p>
                    <ReactTooltip
                      className="custom-tooltip text-center"
                      anchorId="deal-score-tooltip"
                      place="bottom"
                      style={{ maxWidth: "240px" }}
                      clickable={true}
                      closeOnScroll={false}
                      content="Higher Deal Score means better value. It measures performance per dollar using the live price and the model's benchmark score."
                    />
                    <span id="deal-score-tooltip" className="d-flex align-items-center justify-content-center" style={{ cursor: "pointer", flexShrink: 0 }}>
                      <QuestionMarkSvg />
                    </span>
                  </span>

                  {/* GPUwiz Verified - Second Line */}
                  {props?.types !== 2 && (
                    <>
                      <span class="mx-1" className="gpuwiz-verified-line" style={{ 
                        display: 'flex', 
                        flexDirection: 'row',
                        gap: 'clamp(6px, 1.5vw, 10px)',
                        alignItems: 'start',
                        justifyContent: 'flex-start',
                        // marginRight: '108px',
                        width: '100%'
                      }}>
                            <div className="mt-1 ps-1">
                              <svg
                                viewBox="0 0 24 24"
                                width="25"
                                height="25"
                                style={iconStyle}
                                preserveAspectRatio="xMidYMid meet"
                              >
                                <circle cx="12" cy="12" r="12" fill="#1fa940" />
                                <path
                                  d="M7 12l3.5 3.5L17 9"
                                  stroke="#ffffff"
                                  strokeWidth="2.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  fill="none"
                                />
                              </svg>
                            </div>
                        <div className="d-flex flex-column">
                          <div style={{ 
                          fontWeight: 600, 
                          color: '#262626', 
                          fontSize: 'clamp(14px, 2.5vw, 19px)',
                          lineHeight: '1.3'
                        }}>
                          GPUwiz Verified
                        </div>

                         <div >
                          <small style={{ 
                          display: 'block', 
                          color: '#666',
                          fontSize: 'clamp(11px, 1.8vw, 13px)',
                          lineHeight: '1.5',
                          textAlign: 'left',
                          maxWidth: 'clamp(200px, 35vw, 300px)',
                        }}>
                          <b>Benchmarked & function checked: fans, <br/>
                          temps/hotspots, artifacts, ports, load.</b>
                        </small>
                        </div>
                        </div>
                      </span>
                    </>
                  )}
                </div>
                </div>
                
               
              </div>
            </Col>
          </Row>
        ) : null}
      </Container>
    </div>
  );
}
